import { useCallback, useState } from "react";
import { generatePath, useHistory } from "react-router-dom";
import { IScannerProps } from "@yudiel/react-qr-scanner";
import { SearchResult } from "../../../services/search/dataTypes";
import SearchService from "../../../services/search/SearchService";
import pages from "../../../utils/pages";

function useScanner() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [scannerOpen, setScannerOpen] = useState(false);

  const closeScanner = useCallback(() => {
    setScannerOpen(false);
  }, []);

  const openScanner = useCallback(() => {
    setScannerOpen(true);
  }, []);

  const handleSearchResult = useCallback(
    (searchResult: SearchResult) => {
      const path =
        searchResult.type === "Item"
          ? generatePath(pages.PRODUCT_DETAIL.PATH, { product: searchResult.id })
          : generatePath(pages.FIXED_ASSET_INVENTORY.PATH, { product: searchResult.id });

      history.push({ pathname: path });
    },
    [history],
  );

  const handleScan = useCallback<IScannerProps["onScan"]>(
    async scannedBarcodes => {
      if (scannedBarcodes.length === 0) return;

      setIsLoading(true);

      const result = await SearchService.getSearch(scannedBarcodes[0].rawValue);

      if (result.isOk() && result.data != null) {
        handleSearchResult(result.data as SearchResult);
      }

      setIsLoading(false);
      closeScanner();
    },
    [closeScanner, handleSearchResult],
  );

  return { isLoading, scannerOpen, openScanner, handleScan, closeScanner };
}

export default useScanner;
